import { joinSearchParams } from '@modules/common/utils';
import { compressToEncodedURIComponent } from 'lz-string';
import { useGetUser } from 'v2/core/services/user';
import { getDashboardLink } from '../helpers';
import { useDashboardStore } from '../store/useDashboardStore';
import { useGenerateGlobalFilterSearchParamsFromStore } from './useGenerateGlobalFilterSearchParamsFromStore';

export const useGetDashboardLinkWithGlobalFilterParams = () => {
  const searchParamsToAppend: Record<string, string> = {};

  const {
    tenant: { slug: tenantSlug },
  } = useGetUser();

  const { title, viewToken } = useDashboardStore(({ dashboard }) => {
    return { title: dashboard.title, viewToken: dashboard.viewToken };
  });

  const globalFilterSearchParams =
    useGenerateGlobalFilterSearchParamsFromStore();

  const dashboardLink = getDashboardLink({ title, viewToken }, tenantSlug);

  if (globalFilterSearchParams) {
    searchParamsToAppend['queryParameters'] = compressToEncodedURIComponent(
      globalFilterSearchParams,
    );
  }

  if (!Object.keys(globalFilterSearchParams).length) {
    return dashboardLink;
  }

  return `${dashboardLink}?${joinSearchParams(searchParamsToAppend)}`;
};
